// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bulk-pushdown-drawer .drawer-message{margin-bottom:2rem}.bulk-pushdown-drawer .drawer-message button{margin-left:1rem}.bulk-pushdown-drawer .ui-menu{width:220px}", ""]);
// Exports
module.exports = exports;
